
const androidFuncNames = {

    flutter_log  : "flutter_log",
    flutter_loginGoogle  : "flutter_loginGoogle",
    android_loginFacebook: "android_loginFacebook",
    android_logout       : "android_logout",

    android_takeVideo_start  : "android_takeVideo_start",
    android_takeVideo_finish  : "android_takeVideo_finish",
    flutter_takeImage: "flutter_takeImage",

    android_scanQrCode        : "android_scanQrCode",
    android_keyboardListener  : "android_keyboardListener",
    android_batteryLevel        : "android_batteryLevel",

    android_pushNotification : "android_pushNotification",

    android_geoLocationListener_set_f : "android_geoLocationListener_set_f",
    android_geoLocationListener_stop_f : "android_geoLocationListener_stop_f",

    android_getVersion : "android_getVersion",
    android_startUpdate : "android_startUpdate",
}

const flutter = window.FlutterChannel

// flutter_logMe_f
export const flutter_logMe_f = (msg_s) => {
    callFlutterFunc_f({
        funcName_s  : androidFuncNames.flutter_log,
        cb_f        : () => {},
        data_o      : msg_s
    })
}

// flutter_takeImage_f
export const flutter_takeImage_f = () => {
    callFlutterFunc_f({
        funcName_s  : androidFuncNames.flutter_takeImage,
        cb_f        : (image_s) => {
            console.log(image_s)
        },
        data_o      : "-"
    })
}



// =========== private ================

// callAndroidFunc_f
const callFlutterFunc_f = ({funcName_s, cb_f=null, data_o = {}}) => {

    let cbName_s = getCallBackName(funcName_s)
    window[cbName_s] = cb_f

    let dataToSend_o = {
        cbName_s: cbName_s,
        data_o: data_o,
        funcName_s: funcName_s
    }

    flutter.postMessage(JSON.stringify(dataToSend_o))

}

// getCallBackName
const getCallBackName = (funcName_s) => {
    return funcName_s + "_cb"
}